module.exports = __webpack_public_path__ + "static/media/revert-noCirc.ec0e26ad.svg";